import { Globe, Heart, Shield, Award } from 'lucide-react';

export default function About() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Why Choose Chelsea Travel */}
        <div className="mx-auto max-w-3xl text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Why Choose <span className="text-purple-600">Chelsea Travel?</span>
          </h2>
          <p className="text-lg text-gray-700">
            With decades of experience in the South African travel industry, we've built our reputation on creating extraordinary journeys that exceed expectations. Our mission is simple: to share the incredible beauty and diversity of South Africa through personalized travel experiences that create lifelong memories.
          </p>
        </div>

        {/* Trusted Travel Partner Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
          <div className="rounded-2xl overflow-hidden shadow-lg h-80 bg-gray-100 flex items-center justify-center">
            {/* Placeholder image, replace src with real image if available */}
            <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80" alt="South African wildlife" className="object-cover w-full h-full" />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Your Trusted Travel Partner</h3>
            <p className="text-lg text-gray-700 mb-6">
              As proud South Africans, we understand the magic of our homeland like no one else. From the bustling streets of Cape Town to the wild beauty of Kruger National Park, we've personally explored every destination we recommend.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Our team combines international travel standards with authentic local insights, ensuring you experience the real South Africa while enjoying the highest levels of comfort and service.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-extrabold text-purple-600 mb-1">25+</div>
                <div className="text-sm text-gray-700">Years of Excellence</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-extrabold text-purple-600 mb-1">1000+</div>
                <div className="text-sm text-gray-700">Satisfied Clients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-extrabold text-purple-600 mb-1">99%</div>
                <div className="text-sm text-gray-700">Client Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-extrabold text-purple-600 mb-1">24/7</div>
                <div className="text-sm text-gray-700">Travel Support</div>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          <div className="bg-white rounded-xl shadow p-8 flex flex-col items-center text-center">
            <Globe className="h-10 w-10 text-purple-600 mb-4" />
            <h4 className="font-bold text-lg text-gray-900 mb-2">Local South African Expertise</h4>
            <p className="text-gray-700 text-sm">Deep knowledge of South Africa's hidden gems and must-see destinations.</p>
          </div>
          <div className="bg-white rounded-xl shadow p-8 flex flex-col items-center text-center">
            <Heart className="h-10 w-10 text-purple-600 mb-4" />
            <h4 className="font-bold text-lg text-gray-900 mb-2">Personalized Service</h4>
            <p className="text-gray-700 text-sm">Every itinerary is crafted specifically for your unique travel dreams.</p>
          </div>
          <div className="bg-white rounded-xl shadow p-8 flex flex-col items-center text-center">
            <Shield className="h-10 w-10 text-purple-600 mb-4" />
            <h4 className="font-bold text-lg text-gray-900 mb-2">Trusted & Reliable</h4>
            <p className="text-gray-700 text-sm">Decades of experience ensuring your travels are safe and seamless.</p>
          </div>
          <div className="bg-white rounded-xl shadow p-8 flex flex-col items-center text-center">
            <Award className="h-10 w-10 text-purple-600 mb-4" />
            <h4 className="font-bold text-lg text-gray-900 mb-2">Award-Winning Excellence</h4>
            <p className="text-gray-700 text-sm">Recognized for outstanding service and attention to detail.</p>
          </div>
        </div>
      </div>
    </div>
  );
} 